<template>
  <social-proof class="it" :class="{ desktop: $isDesktop }">
    <template #press>
      <div class="press">
        <img
          src="@/assets/homepage/press/corriere-della-sera.svg"
          loading="lazy"
          alt="Corriere Della Sera"
          width="285"
          height="29"
        />
        <img
          src="@/assets/homepage/press/vogue.svg"
          loading="lazy"
          alt="Vogue"
          width="112"
          height="29"
        />
        <img
          src="@/assets/homepage/press/la-repubblica.svg"
          loading="lazy"
          alt="La Repubblica"
          width="153"
          height="29"
        />
        <template v-if="$isDesktop">
          <img
            src="@/assets/homepage/press/il-sole-24-ore.svg"
            loading="lazy"
            alt="Il Sole 24 Ore"
            width="131"
            height="29"
          />
          <img
            src="@/assets/homepage/press/grazia.svg"
            loading="lazy"
            alt="Grazia"
            width="112"
            height="35"
          />
          <img
            src="@/assets/homepage/press/gq.svg"
            loading="lazy"
            alt="GQ"
            width="82"
            height="40"
          />
        </template>
      </div>
    </template>
  </social-proof>
</template>

<script lang="ts">
import { Component, toNative, Vue } from '~/utility/pu-class-decorator'
import SocialProof from './SocialProof.vue'

@Component({
  mixins: [SocialProof],
})
class SocialProofIt extends Vue {}

export default toNative(SocialProofIt)
</script>
<style scoped>
.it:not(.desktop) .press {
  grid-template-columns: auto;
  grid-template-rows: auto auto auto;
  column-gap: 0;
  row-gap: 0.5em;
}

.it:not(.desktop) .press img {
  max-height: 1em;
  max-width: 7em;
}

.it .press img:first-of-type {
  grid-row: unset;
  grid-column: unset;
  margin: 0;
}

/* mobile landscape */
@media screen and (min-width: 320px) and (max-width: 998px) and (orientation: landscape) {
  .it:not(.desktop) .press {
    grid-template-columns: repeat(3, auto);
    grid-template-rows: auto;
    column-gap: 0.75em;
  }

  .it:not(.desktop) .press img:first-of-type {
    grid-row: unset;
    grid-column: unset;
  }
}
</style>
